import { Box } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';

interface Props {
    data: { anonymous?: boolean; firstName?: string | null; lastName?: string | null };
    sx?: SxProps<Theme>;
}

export const FullName: FC<Props> = ({ data, sx }) => {
    const { t } = useTranslation();

    return (
        <Box sx={sx} component="span">
            {data.anonymous || (data.firstName === null && data.lastName === null)
                ? `${t('anonymousLabel')}`
                : `${data.lastName} ${data.firstName}`}
        </Box>
    );
};
